<template>
    <BaseTipsBlock :title="$t('tips_mode_panel.title')" :subtitle="$t('tips_mode_panel.subtitle')">
        <div class="gap-row-xs">
            <div class="option" :class="{
        selected: selectedMode === 'corporate'
    }" @click="selectedMode = 'corporate'">
                <BaseBetaRadioButton v-model="selectedMode" checkedValue="corporate" />
                <div class="gap-row-1xs w-100">
                    <div class="qrw-label-lg bold qrw-text-content-base-primary">
                        {{ $t('tips_mode_panel.option_corporate') }}
                    </div>
                    <div class="qrw-paragraph-sm qrw-text-content-base-secondary">
                        {{ $t('tips_mode_panel.option_corporate_desc') }}
                    </div>
                </div>
            </div>

            <div class="option" :class="{
        selected: selectedMode === 'personal'
    }" @click="selectedMode = 'personal'">
                <BaseBetaRadioButton v-model="selectedMode" checkedValue="personal" />
                <div class="gap-row-1xs w-100">
                    <div class="qrw-label-lg bold qrw-text-content-base-primary">
                        {{ $t('tips_mode_panel.option_personal') }}
                    </div>
                    <div class="qrw-paragraph-sm qrw-text-content-base-secondary">
                        {{ $t('tips_mode_panel.option_personal_desc') }}
                    </div>
                </div>
            </div>
        </div>


    </BaseTipsBlock>
</template>

<style scoped>
.option {
    display: flex;
    flex-direction: row;
    column-gap: 8px;
    align-items: flex-start;
    padding: 16px;
    border-radius: 12px;
    background: var(--qrw-background-base-primary);
    border: 1px solid var(--qrw-border-base-tertiary);
    cursor: pointer;
    box-sizing: border-box;
}

.option.selected {
    background: var(--qrw-background-base-secondary);
}
</style>

<script>
import BaseTipsBlock from './BaseTipsBlock.vue';

export default {
    components: {
        BaseTipsBlock
    },
    computed: {
        cafe () {
            return this.$store.state.cafe;
        },
        selectedMode: {
            get () {
                return this.$store.state.cafe.tips.mode;
            },
            set (v) {
                this.$store.commit('setTipMode', v);
                this.$store.dispatch('saveCafe');
            }
        }
    }
}
</script>